module.exports = __webpack_public_path__ + "static/ugle-meeting-c1a7d89b069c1c8dd02759fb5412c90a.jpg";